import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { IconInvestments } from '@op/opds.opux-icons/business';
import { IconGroceries } from '@op/opds.opux-icons/expenses';
import { IconSavings } from '@op/opds.opux-icons/misc';
import Circle from './Circle';
import Dreams from './Dreams';

interface PlannerColumnProps {
  icon: ReactElement;
  msgId: string;
}

const PlannerColumn = ({ icon, msgId }: PlannerColumnProps): ReactElement => {
  return (
    <div className="investoracademy-planner-column">
      <div className="investoracademy-circle-container">
        <Circle icon={icon} />
      </div>
      <div className="investoracademy-dream-planner-container">
        <div className="investoracademy-planner-content">
          <div className="opds-styles-v1-text-title-large">
            <Message id={msgId} />
          </div>
          <Dreams />
        </div>
      </div>
    </div>
  );
};

const DreamPlanner = (): ReactElement => {
  return (
    <div className="investoracademy-planner-container">
      <PlannerColumn icon={<IconGroceries />} msgId="course4.planner_year1" />
      <PlannerColumn icon={<IconSavings />} msgId="course4.planner_year2" />
      <PlannerColumn icon={<IconInvestments />} msgId="course4.planner_year3" />
    </div>
  );
};

export default DreamPlanner;
